import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { StatusBadge } from "../components/StatusBadge";
import { parseISO } from "../lib/dates";
import { useI18n, useMonthLabel, useT } from "../i18n/I18nContext";

export function HistoryPage() {
  const t = useT();
  const { locale } = useI18n();
  const monthLabel = useMonthLabel();
  const query = useQuery({
    queryKey: ["my-report-list"],
    queryFn: () => api.getMyReportList(),
  });

  const reports = query.data?.reports ?? [];

  return (
    <div className="space-y-4">
      <div>
        <h1 className="font-display text-2xl text-portal-primary sm:text-3xl">
          {t("history.title")}
        </h1>
        <p className="mt-1 text-sm text-text-secondary">
          {t("history.subtitle")}
        </p>
      </div>

      {query.isLoading && (
        <div className="text-text-secondary">{t("app.loading")}</div>
      )}

      {reports.length === 0 && !query.isLoading && (
        <div className="card p-8 text-center text-text-secondary">
          {t("history.empty")}
        </div>
      )}

      <div className="card divide-y divide-border">
        {reports.map((r) => {
          const count = r.entries?.length ?? 0;
          const summary = r.noDeviations
            ? t("history.noDeviations")
            : count === 1
              ? t("history.deviation_one", { count })
              : t("history.deviation_many", { count });
          return (
            <div key={r.id} className="flex items-center justify-between gap-4 px-5 py-4">
              <div>
                <div className="text-base font-semibold text-text-primary">
                  {monthLabel(r.month)} {r.year}
                </div>
                <div className="text-xs text-text-secondary">
                  {summary}
                  {r.submittedAt && (
                    <>
                      {" · "}
                      {t("history.submittedAt", {
                        date: parseISO(r.submittedAt.slice(0, 10)).toLocaleDateString(locale),
                      })}
                    </>
                  )}
                </div>
              </div>
              <StatusBadge status={r.status} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
